import objectAssignPolyfill from "es6-object-assign";
import smoothscroll from "smoothscroll-polyfill";
import ReactGA from "react-ga4";

ReactGA.initialize("G-06TJ7RYWQN");



exports.onRouteUpdate = (state, page, pages) => {

  ReactGA.send({ hitType: "pageview", page: `${state.location.pathname}${state.location.search}` });  
};

exports.onClientEntry = () => {
  objectAssignPolyfill.polyfill();
  smoothscroll.polyfill();
};



// WEBPACK FOOTER //
// ./gatsby-browser.js